var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"cameraMosaicToggle",class:{ 'cameraMosaicToggle--active': _vm.active },attrs:{"icon":"el-icon-s-grid","type":"text"},on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.$t('vehicleDetail.mosaic')))])
}
var staticRenderFns = []

export { render, staticRenderFns }